module.exports = __webpack_public_path__ + "87e43bd09be3b44b3e702567478de06b.MP3";